import '../css/app.scss';
import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';

/** Pages */
import Home from './pages/home';
import Standard from './pages/standard';
import Products from './pages/products';
import Order from './pages/order';

/** Global Components */
import { Header } from './components/header';
import { MobileNavigation } from './components/mobile-navigation';

/** Bootstrap */
// import { Collapse } from 'bootstrap';

$(() => {
	window._$html = $('html');

	// init global components
	window._header = new Header($('[data-header="el"]'));
	window._mobileNavigation = new MobileNavigation(
		$('[data-mobile-nav="trigger"]')
	);

	$('[data-top="el"]').on('click', e => {
		e.preventDefault();

		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	});
	barba.use(barbaPrefetch);

	// console.log('Colllapse', Collapse);

	// $('[data-bs-toggle="collapse"]').each((i, el) => {
	// 	const collapse = new Collapse(el);
	// });

	// init barba
	barba.init({
		timeout: 30000,
		views: [Standard, Home, Products, Order],
		prevent: ({ el }) => {
			return (
				el.href.startsWith('#') ||
				el.href === window.location.href ||
				(el.id && el.id.startsWith('m'))
			);
		},
	});

	window._$html.addClass('initted');
});
